import { parseDate } from '@artup/utilities'
import { Assignable } from '../common/assignable'
import { Account } from './account'

export class Session extends Assignable {
  constructor (data = {}) {
    super(data)
    this.assign({
      ...data,
      created: parseDate(data.created, new Date()),
      updated: parseDate(data.updated, new Date())
    })
  }

  normalize () {
    super.normalize()
    this.created = parseDate(this.created, new Date())
    this.updated = parseDate(this.updated, new Date())
    this.account = this.cast(this.account, Account)
  }

  /**
   * Session identifier
   * @type {String}
   */
  id

  /**
   * API Client identifier
   * @type {String}
   */
  apiClient

  /**
   * Session creation date and time
   * @type {Date}
   */
  created

  /**
   * Session token
   * @type {String}
   */
  token

  /**
   * Session duration in seconds
   * @type {Number}
   */
  expiresIn

  /**
   * Date and time when session expires
   */
  get expiresAt () {
    const { created, expiresIn } = this
    const createdDate = parseDate(created)
    if (createdDate && expiresIn) {
      return new Date(createdDate.getTime() + expiresIn * 1000)
    }
  }

  /**
   * Indicates that session has expired
   * @type {Boolean}
   */
  hasExpired

  /**
   * Logged in account, with permissions
   * @type {Account}
   */
  account

  /**
   * Administrator who logged in on behalf of another account
   * @type {Account}
   */
  masterAccount

  /**
   * Global application preferences
   * @type {Object}
   */
  preferences

  /**
   * Origin IP
   * @type {String}
   */
  ip

  /**
   * Returns true if {@link ip} is a localhost
   * @type {Boolean}
   */
  get isLocalhost () {
    return this.ip === '127.0.0.1' || this.ip === '0.0.0.0'
  }

  /**
   * Origin country
   * @type {String}
   */
  country

  /**
   * Origin city
   * @type {String}
   */
  city

  /**
   * Selected language
   * @type {String}
   */
  language

  /**
   * Browser (from agent string)
   * @type {String}
   */
  browser

  /**
   * OS (from agent string)
   * @type {String}
   */
  os

  /**
   * Device (from agent string)
   * @type {String}
   */
  device

  /**
   * Indicates a valid session with authenticated account
   * @type {Boolean}
   */
  get isValid () {
    return this.token && this.account && !this.hasExpired
  }

  toJSON () {
    const result = { ...this }
    return result
  }
}
